import CurrentStats from 'records/CurrentStats';
import Base from 'records/Base';


import {
  CURRENT_STATS_ASYNC_ACTION_START,
  CURRENT_STATS_ASYNC_ACTION_ERROR,
  CURRENT_STATS_ASYNC_UPDATE_SUCCESS,
  CURRENT_STATS_UPDATE_SUCCESS,
  CURRENT_STATS_RESET_STATE,
} from 'actions/currentStats';


const initialState = new Base({
    loading: false,
    errorMessage: null,
    data: new CurrentStats(),
  });

const actionsMap = {
  [CURRENT_STATS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [CURRENT_STATS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [CURRENT_STATS_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const currentStats = new CurrentStats(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: currentStats,
    });
  },
  [CURRENT_STATS_UPDATE_SUCCESS]: (state, action) => {
    return state.mergeDeep({
      data: action.data,
    });
  },
  [CURRENT_STATS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function currentStatsCount(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
